<template>
  <modal
    v-slot="{ data }"
    name="addGiftCard"
    modal-style="compact"
  >
    <add-gift-card-at-checkout :payment-gateway="data.paymentGateway" />
  </modal>
</template>


<script>
  import AddGiftCardAtCheckout from './add-gift-card-at-checkout/index.vue';


  export default {
    name: 'AddGiftCardAtCheckoutModal',

    components: {
      AddGiftCardAtCheckout
    }
  };
</script>
